import React, { useState, useEffect, useMemo } from 'react';
import moment from 'moment';
import Modal from '../../components/Modal';
import DetailLacak from './DetailLacak';
import FormUploadPo from './FormUploadPo';
import { useSelector } from 'react-redux';
import client from '../../api';
import { NumericFormat } from 'react-number-format';
import { picState } from '../../features/pic/picSlice';
import DateRangeSiberat from '../../components/DateRange';
import { Icon } from '@iconify/react';
import { Stack, Tooltip } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import TableSiberat from '../../components/table/TableSiberat';
import usePageTitle from '../../hooks/usePageTitle';
import { formatExtNo } from '../../utils/formatSDL';
import AddressCell from '../../utils/muatanDisplay';
import ListKubikasi from './ListKubikasi';
import {
  hasSparepartsLoad,
  getOrderLoadsLabel
} from '../../utils/sparepartLoad';

const STATUS_FILTERS = [
  { id: 1, text: 'Semua Status', val: '' },
  { id: 2, text: 'On The Way', val: 'OTW' },
  { id: 3, text: 'Completed', val: 'Completed' },
  { id: 4, text: 'Canceled', val: 'Canceled' }
];

const statusBadgeClass = status => {
  if (status === 'OTW') return 'is-otw';
  if (status === 'Canceled') return 'is-canceled';
  return 'is-completed';
};

const statusLabel = status => {
  if (status === 'OTW') return 'On The Way';
  if (status === 'Canceled') return 'Canceled';
  return 'Completed';
};

const Order = () => {
  usePageTitle('Order');
  const { user } = useSelector(state => state.auth);
  const pic = useSelector(picState);
  const [orderData, setOrderData] = useState({
    rowData: [],
    isLoading: false,
    totalPages: 0,
    totalDataAll: 0,
    totalDataPages: 0,
    total_offer_price: null
  });
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [sizePage, setSizePage] = useState(10);
  const [currentOrderPage, setCurrentOrderPage] = useState(1);
  const [openModal, setOpenModal] = useState(false);
  const [isFormModalOpen, toggleFormModal] = useState(false);
  const [isDetailModalOpen, toggleDetailModal] = useState(false);
  const [isKubikasiModalOpen, toggleKubikasiModal] = useState(false);
  const [orderId, setOrderId] = useState(null);
  const [kubikasiMeta, setKubikasiMeta] = useState(null);
  const [statusOrder, setStatusOrder] = useState('');
  const [search, setSearch] = useState('');
  const [refresh, setRefresh] = useState(false);
  const [dateFilter, setdateFilter] = useState({
    startDate: moment().startOf('month').format('YYYY-MM-DD'),
    endDate: moment().endOf('month').format('YYYY-MM-DD')
  });
  const urlPo = process.env.REACT_APP_PO_URL;

  const columns = useMemo(
    () => [
      { label: 'No', field: 'no', width: '4%', verticalAlign: 'middle' },
      { label: 'Order', field: 'order', width: '24%', verticalAlign: 'middle' },
      { label: 'Lokasi', field: 'route', width: '22%', verticalAlign: 'middle' },
      {
        label: 'Muatan',
        field: 'cargo',
        width: '13%',
        align: 'center',
        verticalAlign: 'middle'
      },
      {
        label: 'Harga',
        field: 'price',
        width: '12%',
        align: 'right',
        verticalAlign: 'middle'
      },
      {
        label: 'Status',
        field: 'status',
        width: '13%',
        align: 'center',
        verticalAlign: 'middle',
        overflow: 'visible'
      },
      {
        label: 'Aksi',
        field: 'actions',
        width: '12%',
        align: 'center',
        verticalAlign: 'middle',
        overflow: 'visible'
      }
    ],
    []
  );

  const rows = useMemo(() => {
    return (orderData?.rowData || []).map((doc, idx) => {
      const startDate = moment(doc?.date_of_loadingplan).startOf('day');
      const endDate = moment(doc?.tgl_est_tiba).startOf('day');
      const hasLeadDates = startDate.isValid() && endDate.isValid();
      // Lead time = selisih hari Est. Tiba − Muat (date_of_loadingplan)
      const leadDays = hasLeadDates ? endDate.diff(startDate, 'days') : null;
      const lead =
        leadDays == null
          ? '-'
          : leadDays <= 0
          ? '1 hari'
          : `${leadDays} hari`;
      const extNo = doc?.ext_no;
      const shortExt = formatExtNo(extNo);
      const muatDate = doc?.date_of_loadingplan
        ? moment(doc.date_of_loadingplan).format('DD MMM YYYY')
        : '-';
      const estTiba = doc?.tgl_est_tiba
        ? moment(doc.tgl_est_tiba).format('DD MMM YYYY')
        : '-';

      return {
        id: parseInt(doc?.order_id),
        no: `${(currentOrderPage - 1) * sizePage + idx + 1}.`,
        order: (
          <div className='order-cell'>
            <Tooltip title={extNo || '-'} placement='top' arrow>
              <span className='order-cell__no'>{shortExt || '-'}</span>
            </Tooltip>
            <div className='order-cell__schedule'>
              <div className='order-cell__schedule-item'>
                <span className='order-cell__schedule-label'>Muat</span>
                <span className='order-cell__schedule-value'>{muatDate}</span>
              </div>
              <span className='order-cell__schedule-arrow' aria-hidden>
                →
              </span>
              <div className='order-cell__schedule-item'>
                <span className='order-cell__schedule-label'>Est. Tiba</span>
                <span className='order-cell__schedule-value'>{estTiba}</span>
              </div>
            </div>
            <Tooltip
              title={
                hasLeadDates
                  ? `Lead time: Est. Tiba − Muat = ${leadDays} hari`
                  : 'Tanggal muat / est. tiba belum lengkap'
              }
              placement='top'
              arrow>
              <span className='order-cell__lead'>Lead Time · {lead}</span>
            </Tooltip>
            {doc?.inv_no ? (
              <span className='order-cell__inv'>Inv: {doc.inv_no}</span>
            ) : null}
          </div>
        ),
        route: (
          <AddressCell
            loading={doc?.loading_place}
            unloading={doc?.unloading_place}
          />
        ),
        cargo: (
          <div className='order-cargo'>
            <div
              className='cargo-clamp'
              dangerouslySetInnerHTML={{ __html: doc?.loads || '-' }}
            />
            {hasSparepartsLoad(doc) ? (
              <button
                type='button'
                className='order-cargo__kubikasi'
                onClick={() => {
                  setKubikasiMeta({
                    jobcosting_id: doc?.jobcosting_id,
                    ext_no: doc?.ext_no,
                    loadsLabel: getOrderLoadsLabel(doc)
                  });
                  setOpenModal(true);
                  toggleKubikasiModal(true);
                }}>
                <Icon icon='solar:box-minimalistic-bold' width={16} />
                Kubikasi
              </button>
            ) : null}
          </div>
        ),
        price: (
          <NumericFormat
            value={parseInt(doc?.costs ?? 0)}
            displayType={'text'}
            thousandSeparator={true}
            prefix={'Rp '}
            renderText={value => (
              <span className='order-price'>{value}</span>
            )}
          />
        ),
        status: (
          <div className='order-cell-center'>
            <span
              className={`order-status-pill ${statusBadgeClass(
                doc?.order_status
              )}`}>
              {statusLabel(doc?.order_status)}
            </span>
          </div>
        ),
        actions: (
          <div className='order-cell-center'>
            <div className='order-actions'>
              {doc?.po_number ? (
                <Tooltip title={`PO: ${doc.po_number}`} placement='top' arrow>
                  <a
                    href={`${urlPo}/${doc?.po_file}`}
                    target='_blank'
                    rel='noreferrer'
                    className='list-page__icon-btn is-po-ok'
                    aria-label={`Lihat PO ${doc.po_number}`}>
                    <Icon icon='solar:document-text-bold' width={18} />
                  </a>
                </Tooltip>
              ) : (
                <Tooltip title='Upload PO' placement='top' arrow>
                  <button
                    type='button'
                    className='list-page__icon-btn'
                    aria-label='Upload PO'
                    onClick={() => {
                      setOpenModal(true);
                      toggleFormModal(true);
                      setOrderId(doc?.order_id);
                    }}>
                    <Icon icon='solar:upload-minimalistic-bold' width={18} />
                  </button>
                </Tooltip>
              )}
              <Tooltip title='Riwayat checkpoint' placement='top' arrow>
                <button
                  type='button'
                  className='list-page__icon-btn'
                  aria-label='Riwayat checkpoint'
                  onClick={() => {
                    setOpenModal(true);
                    toggleDetailModal(true);
                    setOrderId(doc);
                  }}>
                  <Icon icon='solar:map-point-bold' width={18} />
                </button>
              </Tooltip>
            </div>
          </div>
        )
      };
    });
  }, [orderData?.rowData, currentOrderPage, sizePage, urlPo]);

  const footer = useMemo(() => {
    const cells = new Array(columns.length).fill(null);
    cells[0] = {
      colSpan: columns.length,
      className: 'order-table-footer-cell',
      value: (
        <div className='order-summary order-summary--footer'>
          <div className='order-summary__copy'>
            <span className='order-summary__label'>
              Total Order (Keseluruhan)
            </span>
            <span className='order-summary__hint'>
              Berdasarkan filter tanggal & status aktif
            </span>
          </div>
          <span className='order-summary__value'>
            {orderData?.total_offer_price || '-'}
          </span>
        </div>
      )
    };
    return cells;
  }, [columns.length, orderData?.total_offer_price]);

  const handleRefresh = () => {
    setRefresh(!refresh);
  };

  const handleStatus = newValue => {
    setStatusOrder(newValue);
    setCurrentOrderPage(1);
  };

  const getData = async (pageNo = 1, size = 10) => {
    const response = await client.get(
      `/api/customers/orders?page=${pageNo}&sort_by=date_of_loadingplan&sort_order=desc&from=${
        dateFilter.startDate || ''
      }&until=${
        dateFilter.endDate || ''
      }&size=${size}&order_status=${statusOrder}&search=${debouncedSearch}&branch=${pic}`,
      {
        headers: {
          'Content-type': 'application/json',
          Authorization: `Bearer ${user.data.token}`
        }
      }
    );
    return response.data;
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);

    return () => clearTimeout(timer);
  }, [search]);

  // Reset page saat filter berubah — jangan sync page dari API (hindari race/loop)
  useEffect(() => {
    setCurrentOrderPage(prev => (prev === 1 ? prev : 1));
  }, [
    debouncedSearch,
    statusOrder,
    dateFilter.startDate,
    dateFilter.endDate,
    pic
  ]);

  useEffect(() => {
    let cancelled = false;

    setOrderData(prevState => ({
      ...prevState,
      rowData: [],
      isLoading: true
    }));

    getData(currentOrderPage, sizePage)
      .then(info => {
        if (cancelled) return;
        const {
          count,
          rowCount,
          rows,
          totalPages: total_pages,
          total_offer_price
        } = info;
        setOrderData({
          isLoading: false,
          rowData: rows,
          totalPages: total_pages,
          totalDataPages: rowCount,
          total_offer_price: total_offer_price,
          totalDataAll: count
        });
      })
      .catch(() => {
        if (cancelled) return;
        setOrderData(prevState => ({
          ...prevState,
          rowData: [],
          isLoading: false
        }));
      });

    return () => {
      cancelled = true;
    };
  }, [
    currentOrderPage,
    dateFilter.startDate,
    dateFilter.endDate,
    statusOrder,
    sizePage,
    debouncedSearch,
    refresh,
    pic
  ]);

  return (
    <main className='list-page p-4 sm:p-5 space-y-6'>
      <div className='list-page__header'>
        <div className='list-page__title-wrap'>
          <div className='list-page__title-copy'>
            <h1 className='list-page__title'>Order</h1>
            <p className='list-page__subtitle'>
              Pantau status dan dokumen pesanan
            </p>
          </div>
        </div>
        <div className='list-page__actions'>
          <DateRangeSiberat
            value={`${
              dateFilter.startDate
                ? moment(dateFilter.startDate).format('D MMM')
                : moment().startOf('month').format('D MMM')
            } - ${
              dateFilter.endDate
                ? moment(dateFilter.endDate).format('D MMM YYYY')
                : moment().format('D MMM YYYY')
            }`}
            start='startDate'
            end='endDate'
            params={dateFilter}
            setParams={setdateFilter}
          />
          <button
            type='button'
            className={`list-page__refresh${
              orderData.isLoading ? ' is-spinning' : ''
            }`}
            disabled={orderData.isLoading}
            onClick={handleRefresh}
            aria-label='Refresh order'>
            <Icon icon='solar:refresh-bold' width={18} />
          </button>
        </div>
      </div>

      <div className='list-page__card'>
        <div className='list-page__toolbar'>
          <div className='list-page__toolbar-left'>
            <div className='list-page__search'>
              <SearchIcon className='list-page__search-icon' fontSize='small' />
              <input
                type='text'
                className='list-page__search-input'
                placeholder='Cari data...'
                value={search}
                onChange={e => setSearch(e.target.value)}
              />
              {search && (
                <button
                  type='button'
                  onClick={() => setSearch('')}
                  aria-label='Clear search'
                  className='list-page__search-clear'>
                  <CloseIcon sx={{ fontSize: 14 }} />
                </button>
              )}
            </div>
          </div>

          <div className='list-page__chips'>
            {STATUS_FILTERS.map(val => (
              <button
                key={val.id}
                type='button'
                onClick={() => handleStatus(val.val)}
                className={`list-page__chip${
                  statusOrder === val.val ? ' is-active' : ''
                }`}>
                {val.text}
              </button>
            ))}
          </div>
        </div>

        <TableSiberat
          columns={columns}
          rows={rows}
          loading={orderData.isLoading}
          pagination
          page={currentOrderPage}
          pageCount={orderData.totalPages || 1}
          pageSize={sizePage}
          total={orderData.totalDataAll || 0}
          onPageChange={value => setCurrentOrderPage(value)}
          onPageSizeChange={value => {
            setSizePage(value);
            setCurrentOrderPage(1);
          }}
          footer={footer}
        />
      </div>

      {isFormModalOpen ? (
        <Modal
          open={openModal}
          onClose={() => {
            setOpenModal(false);
            toggleFormModal(false);
            setOrderId(null);
          }}
          title='Form Upload PO'>
          <FormUploadPo
            orderId={orderId}
            onClose={() => {
              setOpenModal(false);
              toggleFormModal(false);
              setOrderId(null);
            }}
            refresh={() => handleRefresh()}
          />
        </Modal>
      ) : null}

      {isDetailModalOpen ? (
        <Modal
          open={openModal}
          onClose={() => {
            setOpenModal(false);
            toggleDetailModal(false);
            setOrderId(null);
          }}
          customTitle={true}
          title={
            <div className='lacak-modal__title'>
              <div className='lacak-modal__heading-block'>
                <h2 className='lacak-modal__heading'>Riwayat Checkpoint</h2>
                <p className='lacak-modal__order-no'>
                  {formatExtNo(orderId?.ext_no) || orderId?.ext_no || '-'}
                </p>
              </div>
              <span
                className={`lacak-modal__chip ${statusBadgeClass(
                  orderId?.order_status
                )}`}>
                {statusLabel(orderId?.order_status)}
              </span>
            </div>
          }>
          <DetailLacak
            detailOrder={orderId}
            onClose={() => {
              setOpenModal(false);
              toggleDetailModal(false);
              setOrderId(null);
            }}
          />
        </Modal>
      ) : null}

      {isKubikasiModalOpen ? (
        <Modal
          open={openModal}
          width='w-11/12 md:max-w-5xl'
          onClose={() => {
            setOpenModal(false);
            toggleKubikasiModal(false);
            setKubikasiMeta(null);
          }}
          customTitle={true}
          title={
            <Stack direction='row' gap={2} sx={{ alignItems: 'center' }}>
              <h2 className='siberat-modal__heading border-r border-[#E5E7EB] pr-3'>
                Kubikasi
              </h2>
              <span className='dashboard-doc-chip is-ok'>
                {formatExtNo(kubikasiMeta?.ext_no) ||
                  kubikasiMeta?.ext_no ||
                  '-'}
              </span>
            </Stack>
          }>
          <ListKubikasi
            jobcostingId={kubikasiMeta?.jobcosting_id}
            sdlLabel={formatExtNo(kubikasiMeta?.ext_no) || kubikasiMeta?.ext_no}
            loadsLabel={kubikasiMeta?.loadsLabel}
          />
        </Modal>
      ) : null}
    </main>
  );
};

export default Order;
